import gql from 'graphql-tag';

export const DELETE_EVENT = gql`
	mutation delete_events_by_pk($id: uuid!) {
		delete_events_by_pk(id: $id) {
			id
		}
	}
`;
